import React, {useState, useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {logPageLoadEvents} from '@ibibo/analytics';
import {Helmet} from 'react-helmet';
import IconSelector from '@ibibo/icon-selector';
import {getCookie} from '../../../utils/getCookie';
import {redirectToSameWindowWithoutRefresh,redirectToSameWindowWithRefresh, getCrid} from '../../../utils/redirectWithCrId';

import {
  fetchWalletData,
  fetchWalletBrekupData,
  rechargeWallet,
  walletDataSelector,
  walletBreakupSelector,
  rechargeStatusSelector,
  myTripsStatementLoaderSelector,
  getNeftRechargeDetails,
  neftDetailsLoaderSelector,
  vandeBharatDataSelector,
  earnMoreDataSelector,
  walletPromotionConfigDataSelector,
} from '@ibibo/myaccount-reducer';
import {fetchUserDetails} from '@ibibo/user-reducer';
import {userSelector} from '@ibibo/user-reducer';

import * as S from './Wallet.styles';

import LeftBlock from './LeftBlock/LeftBlock';
import RightBlock from './RightBlock/RightBlock';
import WalletBalance from './WalletBalance/WalletBalance';
import MyCash from './MyCash/MyCash';
import FaqBlock from './FaqBlock/FaqBlock';
import WalletStatement from './RightBlock/WalletStatement/WalletStatement';
import EarnMore from './EarnMore/EarnMore';
import {getEarnMoreData, getEarnMoreDataAed} from './EarnMore/data';
import AddCashWrapper from './AddCashWrapper/AddCashWrapper';
//import { refundRaiseRequestListing } from 'myaccount/myaccount-reducer/src/myaccount-constants';

const Wallet = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ccdeCookie = getCookie('ccde');

  const fetchwalletDataCaller = useCallback(
    data => {
      return dispatch(fetchWalletData(data));
    },
    [dispatch],
  );

  const fetchwalletBreakupCaller = useCallback(() => {
    return dispatch(fetchWalletBrekupData());
  }, [dispatch]);

  const fetchUserDetailsCaller = useCallback(() => {
    return dispatch(fetchUserDetails());
  }, [dispatch]);

  // useEffect(() => {
  //   if(deviceWidth < 1024){
  //     window.open('/agent/mobile', '_self');
  //   }
  // }, [deviceWidth]);

  useEffect(() => {
    redirectToSameWindowWithRefresh('/coreui/wallet');
    
  }, []);

  useEffect(() => {
    fetchwalletDataCaller();
    fetchwalletBreakupCaller();
    const crId = getCrid();
    if (!crId) {
      redirectToSameWindowWithoutRefresh('/coreui/wallet');
    }
  }, []);

  useEffect(() => {
    logPageLoadEvents('MyWalletPage', {});
  }, []);

  const [openPayment, setOpenPayment] = useState(false);
  const [paymentsData, setPaymentsData] = useState(null);

  const walletData = useSelector(walletDataSelector);
  const walletBreakup = useSelector(walletBreakupSelector);
  const rechargeStatus = useSelector(rechargeStatusSelector);
  const isStatementLoading = useSelector(myTripsStatementLoaderSelector);
  const userInfo = useSelector(userSelector);
  const wlBlock = userInfo.walletBlacklist;
  const [showPop, setShowPop] = useState(false);
  const vandeBharat = useSelector(vandeBharatDataSelector);
  const earnMoreData = useSelector(earnMoreDataSelector);
  const walletPromotionConfigData = useSelector(walletPromotionConfigDataSelector);
  const earnMore = userInfo.earnMore || {};
  const isLoyal = userInfo.earnMore[0]?.is_loyal || false;
  const is_sub_user = userInfo?.userInfo?.is_sub_user || false;

  useEffect(() => {
    if (vandeBharat.user_enabled) {
      history.goBack();
    }
  }, [vandeBharat]);

  useEffect(() => {
    if (wlBlock?.block) {
      setShowPop(true);
    } else {
      setShowPop(false);
    }
  }, [wlBlock]);
  const neftLoader = useSelector(neftDetailsLoaderSelector);

  const [showNeftPop, setShowNeftPop] = useState(false);
  const [neftDataUp, setNeftDataUp] = useState(false);
  const [neftDetails, setNeftDetails] = useState(null);
  const [neftApiError, setNeftApiError] = useState(false);
  const [neftError, setNeftError] = useState(null);

  useEffect(() => {
    if (rechargeStatus) {
      fetchUserDetailsCaller();
      fetchwalletDataCaller();
      fetchwalletBreakupCaller();
      window.history.replaceState({}, 'wallet', '/coreui/wallet/');
    }
  }, [rechargeStatus]);

  if (rechargeStatus) {
    useEffect(() => {
      logPageLoadEvents('MyWalletPage:Thankyou', {});
    }, []);
  }

  const successCallback = response => {
    // setPaymentsData(response);
    window.open(response?.data?.checkoutUrl, '_self');
  };

  const errorCallback = () => {
    setOpenPayment(false);
  };

  const closePayments = () => {
    setOpenPayment(false);
  };

  const addBalanceToWallet = amt => {
    dispatch(rechargeWallet(amt, successCallback, errorCallback));
  };

  const updateDateParams = data => {
    fetchwalletDataCaller(data);
  };

  const homeRedirect = () => {
    history.goBack();
  };

  const fetchNeftDetailsCaller = () => {
    setShowNeftPop(true);
    dispatch(getNeftRechargeDetails(neftSuccessCallback, neftErrorCallBack));
  };

  const neftSuccessCallback = data => {
    setNeftDataUp(true);
    setNeftDetails(data);
  };

  const neftErrorCallBack = () => {
    setNeftApiError(true);
    setNeftError('Something went wrong please try again later!');
  };

  const closeDetailPop = () => {
    setShowNeftPop(false);
  };

  const useViewport = () => {
    const [width, setWidth] = useState(typeof window === 'undefined' ? 800 : window.innerWidth);
    React.useLayoutEffect(() => {
      const handleWindowResize = () => setWidth(window.innerWidth);

      window.addEventListener('resize', handleWindowResize);
      return () => window.removeEventListener('resize', handleWindowResize);
    }, []);
    return {width};
  };

  const {width} = useViewport();
  const breakpoint = 766;

  return (
    <S.WalletMainWrap>
      <Helmet
        title={'myPartner by MakeMyTrip'}
        meta={[{name: 'robots', content: 'noindex, nofollow'}]}
      />
      {width > breakpoint ? null : <WalletBalance walletBreakup={walletBreakup} />}
      <S.WalletTopBack />
      <S.WalletOuterWrap>
        {(rechargeStatus && (
          <S.RechargeStatusWrap>
            <S.RechargeStatus success={rechargeStatus.success}>
              {rechargeStatus.msg}
            </S.RechargeStatus>
          </S.RechargeStatusWrap>
        )) ||
          null}
        <S.Left>
          <MyCash walletBreakup={walletBreakup} />
          {width > breakpoint && <FaqBlock />}
        </S.Left>
        <S.Right>
          {isLoyal && (
            <EarnMore
              walletPromotionConfigData={walletPromotionConfigData}
              bannersArray={earnMoreData[0]?.benefitUrls}
              {...(ccdeCookie === 'AE'
                ? getEarnMoreDataAed(earnMore[0] || {})
                : getEarnMoreData(earnMore[0] || {}))}
              ccdeCookie={ccdeCookie}
            />
          )}
          {ccdeCookie !== 'AE' ? (
            <AddCashWrapper
              isLoyal={earnMoreData ? earnMore[0]?.is_loyal : false}
              earnMore={earnMore}
              addBalanceToWallet={addBalanceToWallet}
              openPayment={openPayment}
              closePayments={closePayments}
              neftDetailsCaller={fetchNeftDetailsCaller}
              blacklistBlock={wlBlock}
              earnMoreData={earnMoreData}
              is_sub_user={is_sub_user}
            />
          ) : null}
          <section key="walletSection" id="walletSection">
            <WalletStatement
              walletData={walletData}
              isLoading={isStatementLoading}
              updateDateParams={updateDateParams}
              ccdeCookie={ccdeCookie}
              is_sub_user={is_sub_user}
            />
          </section>
          {width < breakpoint && <FaqBlock />}
        </S.Right>
      </S.WalletOuterWrap>
      {(showNeftPop && (
        <S.NeftDetailInfoPop>
          <S.NeftDetailsInfoPopWrap>
            <S.NeftDetailPopCloseBtn onClick={closeDetailPop}>
              <IconSelector iconKey="close" props={{width: '1.2rem', height: '1.2rem'}} />
            </S.NeftDetailPopCloseBtn>
            {neftLoader ? (
              <IconSelector iconKey="linearloader" props={{top: '50%', width: '20rem'}} />
            ) : (
              (
                <S.NeftDetailMainWrapper>
                  <S.NeftDetailHeadWrap>
                    <S.NeftDetailsHeadText>{neftDetails.heading}</S.NeftDetailsHeadText>
                  </S.NeftDetailHeadWrap>
                  <S.NeftDetailInfoInnerWrap>
                    <S.NeftDetailInfoText>{neftDetails.line1}</S.NeftDetailInfoText>
                    <S.NeftDetailsInfoSubText>{neftDetails.line2}</S.NeftDetailsInfoSubText>
                  </S.NeftDetailInfoInnerWrap>
                  {neftDetails?.bank_details?.length > 0 &&
                    neftDetails?.bank_details.map((item, idx) => {
                      return (
                        <S.NeftAccountDetailsWrap>
                          {item?.length > 0 &&
                            item.map(({key, value}) => {
                              return (
                                <S.NeftAccountDetailInnerWrap key={key}>
                                  <S.NeftAccountDetailTypeText>{key}</S.NeftAccountDetailTypeText>
                                  <S.NeftAccountDetailInfoText>{value}</S.NeftAccountDetailInfoText>
                                </S.NeftAccountDetailInnerWrap>
                              );
                            })}
                        </S.NeftAccountDetailsWrap>
                      );
                    })}
                </S.NeftDetailMainWrapper>
              ) || <S.ErrorText>{neftError}</S.ErrorText>
            )}
          </S.NeftDetailsInfoPopWrap>
        </S.NeftDetailInfoPop>
      )) ||
        []}
      {(showPop && (
        <S.BlackListPopupOverlay>
          <S.BlacklistPopupWrap>
            <S.BlackListInfoText>{wlBlock?.message}</S.BlackListInfoText>
            <S.BlackListHomeBtn onClick={homeRedirect}>Go Back</S.BlackListHomeBtn>
          </S.BlacklistPopupWrap>
        </S.BlackListPopupOverlay>
      )) ||
        null}
    </S.WalletMainWrap>
  );
};

export default Wallet;
